const getFullyVisibleScrollTarget = (
  scrollTo: number | undefined,
  itemCount: number,
) => {
  if (!scrollTo || !itemCount) {
    return undefined;
  }
  const lastIndex = itemCount - 1;
  if (scrollTo < lastIndex) {
    return scrollTo + 1;
  }
  if (scrollTo === lastIndex) {
    return scrollTo;
  }
  return undefined;
};

export default getFullyVisibleScrollTarget;
